/*
 * hfd-points.js — карта пунктов выдачи HFD (sections/ds-hfd-points.liquid).
 *
 * Данные: бэкенд amitea-dashboard/hfd — GET {api}/hfd/points (все точки,
 * ~50 КБ gzip) и GET {api}/hfd/cities (города с переводами RU/EN). Оба
 * запроса и Leaflet из assets грузятся лениво, когда карта подходит к
 * экрану на 200px.
 *
 * Режимы показа (решение владельца 13.09: без кластеризации):
 *   город   — маркеры и список точек одного города (по умолчанию defaultCity
 *             из настроек, обычно Тель-Авив); поиск по he/ru/en названию;
 *   рядом   — Geolocation API → 10 ближайших точек с расстоянием;
 *   все     — все 935 маркеров по кнопке «Показать все», список скрыт.
 * Фильтр магазины/локеры действует во всех режимах. Маркеры — circleMarker
 * на canvas-рендерере.
 *
 * Карточка точки у карты (десктоп — слева, мобайл — под картой) заполняется
 * по клику на маркер или карточку списка. Адреса/часы на иврите — dir=auto.
 * Город в URL (?city=<иврит>) — чтобы ссылку на город можно было отправить.
 *
 * Инициализация идемпотентна (data-hfd-ready), Theme Editor перерисовывает
 * секцию целиком — слушаем shopify:section:load.
 */

(function () {
  if (window.dsHfdPoints) return;
  window.dsHfdPoints = true;

  var NEAR_LIMIT = 10;
  var SEARCH_LIMIT = 8;
  var leafletPromise = null;

  function loadLeaflet(jsUrl, cssUrl) {
    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;
    leafletPromise = new Promise(function (resolve, reject) {
      if (cssUrl && !document.querySelector('link[data-leaflet-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssUrl;
        link.setAttribute('data-leaflet-css', '');
        document.head.appendChild(link);
      }
      var script = document.createElement('script');
      script.src = jsUrl;
      script.defer = true;
      script.onload = function () { resolve(window.L); };
      script.onerror = function () { leafletPromise = null; reject(new Error('leaflet')); };
      document.head.appendChild(script);
    });
    return leafletPromise;
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  function fill(template, vars) {
    return String(template || '').replace(/\[(\w+)\]/g, function (m, key) {
      return key in vars ? vars[key] : m;
    });
  }

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[-–—'’"״׳.]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function distanceKm(a, b) {
    var R = 6371;
    var dLat = (b.lat - a.lat) * Math.PI / 180;
    var dLng = (b.lng - a.lng) * Math.PI / 180;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }

  function formatKm(km, unit) {
    var n = km < 10 ? Math.round(km * 10) / 10 : Math.round(km);
    return String(n).replace('.', ',') + ' ' + unit;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  var STYLE = {
    shop: { radius: 7, color: '#fffdf9', weight: 1.5, fillColor: '#bf8f24', fillOpacity: 0.95 },
    locker: { radius: 7, color: '#fffdf9', weight: 1.5, fillColor: '#3b2416', fillOpacity: 0.95 },
    shopSelected: { radius: 10, color: '#3b2416', weight: 3, fillColor: '#bf8f24', fillOpacity: 1 },
    lockerSelected: { radius: 10, color: '#bf8f24', weight: 3, fillColor: '#3b2416', fillOpacity: 1 },
    me: { radius: 8, color: '#fffdf9', weight: 2, fillColor: '#2f7d3d', fillOpacity: 1 }
  };

  function initRoot(root) {
    if (root.hasAttribute('data-hfd-ready')) return;
    root.setAttribute('data-hfd-ready', '');

    var configNode = root.querySelector('[data-hfd-config]');
    var mapEl = root.querySelector('[data-hfd-map]');
    if (!configNode || !mapEl) return;
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (e) { return; }
    var L10N = config.labels || {};
    var locale = config.locale || 'ru';

    var q = function (sel) { return root.querySelector(sel); };
    var ui = {
      status: q('[data-hfd-status]'),
      searchInput: q('[data-hfd-search-input]'),
      searchClear: q('[data-hfd-search-clear]'),
      searchList: q('[data-hfd-search-list]'),
      near: q('[data-hfd-near]'),
      types: Array.prototype.slice.call(root.querySelectorAll('[data-hfd-type]')),
      showAll: q('[data-hfd-show-all]'),
      updated: q('[data-hfd-updated]'),
      fallback: q('[data-hfd-fallback]'),
      list: q('[data-hfd-list]'),
      listHeading: q('[data-hfd-list-heading]'),
      grid: q('[data-hfd-grid]'),
      detail: q('[data-hfd-detail]'),
      detailEmpty: q('[data-hfd-detail-empty]'),
      detailCard: q('[data-hfd-detail-card]'),
      detailType: q('[data-hfd-detail-type]'),
      detailName: q('[data-hfd-detail-name]'),
      detailAddress: q('[data-hfd-detail-address]'),
      detailHours: q('[data-hfd-detail-hours]'),
      detailBadges: q('[data-hfd-detail-badges]'),
      detailCode: q('[data-hfd-detail-code]'),
      detailRoute: q('[data-hfd-detail-route]')
    };
    var desktop = window.matchMedia('(min-width: 990px)');

    var points = [];
    var cities = [];
    var cityByHe = {};
    var map = null;
    var L = null;
    var renderer = null;
    var markers = {}; // code → marker
    var meMarker = null;

    var state = {
      mode: 'city', // city | near | all
      city: '',
      type: '',
      me: null,
      selected: null
    };

    /* ---------- города ---------- */

    function cityName(he) {
      var c = cityByHe[he];
      if (!c) return he;
      if (locale === 'he') return he;
      if (locale === 'ru') return c.ru || he;
      return c.en || he;
    }

    function searchCities(query) {
      var nq = norm(query);
      if (!nq) return [];
      var hits = [];
      cities.forEach(function (c) {
        var names = [c.he, c.ru, c.en].filter(Boolean).map(norm);
        var rank = -1;
        names.forEach(function (n) {
          if (n.indexOf(nq) === 0) rank = Math.max(rank, 2);
          else if (n.indexOf(nq) >= 0) rank = Math.max(rank, 1);
        });
        if (rank > 0) hits.push({ city: c, rank: rank });
      });
      hits.sort(function (a, b) { return b.rank - a.rank || b.city.count - a.city.count; });
      return hits.slice(0, SEARCH_LIMIT).map(function (h) { return h.city; });
    }

    function closeSearch() {
      ui.searchList.hidden = true;
      ui.searchList.innerHTML = '';
      ui.searchInput.setAttribute('aria-expanded', 'false');
    }

    function renderSearch(query) {
      var hits = searchCities(query);
      ui.searchList.innerHTML = '';
      if (!query) { closeSearch(); return; }
      if (!hits.length) {
        var none = el('li', 'hfd-search__none', L10N.noResults);
        ui.searchList.appendChild(none);
      }
      hits.forEach(function (c, i) {
        var li = el('li', 'hfd-search__item');
        li.setAttribute('role', 'option');
        li.setAttribute('id', ui.searchList.id + '-' + i);
        li.setAttribute('data-hfd-city-option', c.he);
        var main = el('span', 'hfd-search__item-name', cityName(c.he));
        li.appendChild(main);
        if (cityName(c.he) !== c.he) {
          var he = el('span', 'hfd-search__item-he', c.he);
          he.setAttribute('dir', 'rtl');
          li.appendChild(he);
        }
        li.appendChild(el('span', 'hfd-search__item-count', String(c.count)));
        li.addEventListener('mousedown', function (e) { e.preventDefault(); });
        li.addEventListener('click', function () { pickCity(c.he); });
        ui.searchList.appendChild(li);
      });
      ui.searchList.hidden = false;
      ui.searchInput.setAttribute('aria-expanded', 'true');
    }

    /* ---------- выборка точек ---------- */

    function typeOk(p) { return !state.type || p.type === state.type; }

    function visiblePoints() {
      var list;
      if (state.mode === 'all') {
        list = points.filter(typeOk);
      } else if (state.mode === 'near' && state.me) {
        list = points.filter(typeOk).map(function (p) {
          return { p: p, d: distanceKm(state.me, p) };
        }).sort(function (a, b) { return a.d - b.d; }).slice(0, NEAR_LIMIT).map(function (x) {
          x.p.distance = x.d;
          return x.p;
        });
      } else {
        list = points.filter(function (p) { return p.city === state.city && typeOk(p); });
        list.sort(function (a, b) { return a.name.localeCompare(b.name, 'he'); });
      }
      return list;
    }

    /* ---------- карточка точки ---------- */

    function markerStyle(p, selected) {
      if (selected) return p.type === 'locker' ? STYLE.lockerSelected : STYLE.shopSelected;
      return p.type === 'locker' ? STYLE.locker : STYLE.shop;
    }

    function addressOf(p) {
      var street = [p.street, p.house].filter(Boolean).join(' ');
      return street ? street + ', ' + p.city : p.city;
    }

    function routeUrl(p) {
      return 'https://www.google.com/maps/dir/?api=1&destination=' + p.lat + ',' + p.lng;
    }

    function badgesInto(container, p) {
      container.innerHTML = '';
      if (p.returns) container.appendChild(el('span', 'hfd-badge', L10N.returns));
      if (p.accessible) container.appendChild(el('span', 'hfd-badge', L10N.accessible));
      container.hidden = !container.childNodes.length;
    }

    function unselect() {
      if (state.selected && markers[state.selected.code]) {
        markers[state.selected.code].setStyle(markerStyle(state.selected, false));
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-hfd-card][aria-current]'), function (card) {
        card.removeAttribute('aria-current');
      });
      state.selected = null;
    }

    function showPlaceholder() {
      unselect();
      ui.detailCard.hidden = true;
      ui.detailEmpty.hidden = false;
    }

    function select(p, opts) {
      opts = opts || {};
      unselect();
      state.selected = p;
      var marker = markers[p.code];
      if (marker) {
        marker.setStyle(markerStyle(p, true));
        marker.bringToFront();
        if (opts.pan && map) map.panTo([p.lat, p.lng]);
      }
      var card = root.querySelector('[data-hfd-card="' + p.code + '"]');
      if (card) card.setAttribute('aria-current', 'true');

      var typeLabel = p.type === 'locker' ? L10N.locker : L10N.shop;
      ui.detailType.textContent = typeLabel + ' · ' + cityName(p.city);
      ui.detailName.textContent = p.name;
      ui.detailAddress.textContent = addressOf(p);
      ui.detailHours.textContent = p.hours || '';
      ui.detailHours.hidden = !p.hours;
      badgesInto(ui.detailBadges, p);
      ui.detailCode.textContent = p.code;
      ui.detailRoute.href = routeUrl(p);
      ui.detailEmpty.hidden = true;
      ui.detailCard.hidden = false;

      if (opts.scroll && !desktop.matches && ui.detail.scrollIntoView) {
        ui.detail.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    /* ---------- список ---------- */

    function renderList(list) {
      ui.grid.innerHTML = '';
      if (state.mode === 'all') {
        ui.listHeading.textContent = '';
        ui.list.hidden = true;
        return;
      }
      ui.listHeading.textContent = state.mode === 'near'
        ? L10N.listNear
        : fill(L10N.listCity, { city: cityName(state.city), count: list.length });
      list.forEach(function (p) {
        var card = el('article', 'hfd-card');
        card.setAttribute('data-hfd-card', p.code);

        var head = el('span', 'hfd-card__head');
        head.appendChild(el('span', 'hfd-dot hfd-dot--' + p.type));
        var name = el('span', 'hfd-card__name', p.name);
        name.setAttribute('dir', 'auto');
        head.appendChild(name);
        card.appendChild(head);

        var address = el('span', 'hfd-card__address', addressOf(p));
        address.setAttribute('dir', 'auto');
        card.appendChild(address);

        if (p.hours) {
          var hours = el('span', 'hfd-card__hours', p.hours);
          hours.setAttribute('dir', 'auto');
          card.appendChild(hours);
        }

        var meta = el('span', 'hfd-card__meta');
        meta.appendChild(el('span', 'hfd-card__type', p.type === 'locker' ? L10N.locker : L10N.shop));
        if (p.returns) meta.appendChild(el('span', 'hfd-badge', L10N.returns));
        if (p.accessible) meta.appendChild(el('span', 'hfd-badge', L10N.accessible));
        if (state.mode === 'near' && typeof p.distance === 'number') {
          meta.appendChild(el('span', 'hfd-card__distance', formatKm(p.distance, L10N.km)));
        }
        meta.appendChild(el('span', 'hfd-card__code', L10N.code + ' ' + p.code));
        card.appendChild(meta);

        var links = el('span', 'hfd-card__links');
        var pick = el('button', 'hfd-pill', L10N.onMap);
        pick.type = 'button';
        pick.addEventListener('click', function () {
          select(p, { pan: true });
          if (mapEl.scrollIntoView) mapEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
        links.appendChild(pick);
        var route = el('a', 'hfd-pill hfd-pill--accent', L10N.route);
        route.href = routeUrl(p);
        route.target = '_blank';
        route.rel = 'noopener';
        links.appendChild(route);
        card.appendChild(links);

        ui.grid.appendChild(card);
      });
      ui.list.hidden = false;
    }

    /* ---------- карта ---------- */

    function renderMarkers(list) {
      if (!map) return;
      Object.keys(markers).forEach(function (code) { map.removeLayer(markers[code]); });
      markers = {};
      list.forEach(function (p) {
        var marker = L.circleMarker([p.lat, p.lng], Object.assign({ renderer: renderer }, markerStyle(p, false))).addTo(map);
        marker.on('click', function () { select(p, { scroll: true }); });
        markers[p.code] = marker;
      });
      if (meMarker) { map.removeLayer(meMarker); meMarker = null; }
      if (state.mode === 'near' && state.me) {
        meMarker = L.circleMarker([state.me.lat, state.me.lng], Object.assign({ renderer: renderer, interactive: false }, STYLE.me)).addTo(map);
      }
    }

    function fitTo(list) {
      if (!map) return;
      var latlngs = list.map(function (p) { return [p.lat, p.lng]; });
      if (state.mode === 'near' && state.me) latlngs.push([state.me.lat, state.me.lng]);
      if (!latlngs.length) return;
      if (latlngs.length === 1) { map.setView(latlngs[0], 15); return; }
      map.fitBounds(L.latLngBounds(latlngs), { padding: [36, 36], maxZoom: state.mode === 'all' ? 8 : 15 });
    }

    /* ---------- состояние ---------- */

    function setStatus(text) {
      ui.status.textContent = text || '';
      ui.status.hidden = !text;
    }

    function syncUrl() {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (state.mode === 'city' && state.city) url.searchParams.set('city', state.city);
        else url.searchParams.delete('city');
        window.history.replaceState(null, '', url.toString());
      } catch (e) { /* старые браузеры */ }
    }

    function render(opts) {
      opts = opts || {};
      var list = visiblePoints();
      var keepSelected = state.selected && list.some(function (p) { return p.code === state.selected.code; });
      var selectedCode = keepSelected ? state.selected.code : null;
      if (!keepSelected) showPlaceholder();

      if (state.mode === 'all') {
        setStatus(fill(L10N.allStatus, { count: list.length }));
      } else if (state.mode === 'near') {
        setStatus(L10N.nearStatus);
      } else {
        setStatus(fill(L10N.cityStatus, { city: cityName(state.city), count: list.length }));
      }
      ui.showAll.setAttribute('aria-pressed', state.mode === 'all' ? 'true' : 'false');
      ui.showAll.textContent = state.mode === 'all' && state.city
        ? fill(L10N.showCity, { city: cityName(state.city) })
        : L10N.showAll;
      ui.near.setAttribute('aria-pressed', state.mode === 'near' ? 'true' : 'false');
      ui.types.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-hfd-type') === state.type ? 'true' : 'false');
      });

      renderMarkers(list);
      renderList(list);
      if (state.mode === 'all') {
        var hint = el('p', 'hfd__list-hint', L10N.listAll);
        ui.grid.appendChild(hint);
        ui.list.hidden = false;
      }
      if (opts.fit !== false) fitTo(list);
      if (selectedCode) {
        var again = list.filter(function (p) { return p.code === selectedCode; })[0];
        if (again) select(again);
      }
      syncUrl();
    }

    function pickCity(he) {
      state.mode = 'city';
      state.city = he;
      ui.searchInput.value = cityName(he);
      ui.searchClear.hidden = false;
      closeSearch();
      render();
    }

    function toggleAll() {
      if (state.mode === 'all') {
        state.mode = state.me ? 'near' : 'city';
        if (state.mode === 'city' && !state.city) state.city = config.defaultCity;
      } else {
        state.mode = 'all';
      }
      render();
    }

    function locate() {
      if (state.mode === 'near') {
        state.mode = 'city';
        if (!state.city) state.city = config.defaultCity;
        render();
        return;
      }
      if (!navigator.geolocation) { setStatus(L10N.nearError); return; }
      setStatus(L10N.nearWait);
      ui.near.disabled = true;
      navigator.geolocation.getCurrentPosition(function (pos) {
        ui.near.disabled = false;
        state.me = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        state.mode = 'near';
        ui.searchInput.value = '';
        ui.searchClear.hidden = true;
        render();
      }, function () {
        ui.near.disabled = false;
        setStatus(L10N.nearError);
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    }

    /* ---------- события ---------- */

    ui.searchInput.addEventListener('input', function () {
      ui.searchClear.hidden = !ui.searchInput.value;
      renderSearch(ui.searchInput.value);
    });
    ui.searchInput.addEventListener('focus', function () {
      if (ui.searchInput.value && ui.searchInput.value !== cityName(state.city)) renderSearch(ui.searchInput.value);
    });
    ui.searchInput.addEventListener('blur', function () { setTimeout(closeSearch, 120); });
    ui.searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = ui.searchList.querySelector('[data-hfd-city-option]');
        if (first) pickCity(first.getAttribute('data-hfd-city-option'));
      } else if (e.key === 'Escape') {
        closeSearch();
      }
    });
    ui.searchClear.addEventListener('click', function () {
      ui.searchInput.value = '';
      ui.searchClear.hidden = true;
      closeSearch();
      ui.searchInput.focus();
    });
    ui.near.addEventListener('click', locate);
    ui.showAll.addEventListener('click', toggleAll);
    ui.types.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.type = btn.getAttribute('data-hfd-type') || '';
        render({ fit: state.mode !== 'city' });
      });
    });

    /* ---------- загрузка ---------- */

    function fail() {
      setStatus('');
      ui.fallback.hidden = false;
      ui.showAll.hidden = true;
      mapEl.hidden = true;
      ui.detail.hidden = true;
    }

    function start() {
      var api = String(config.api || '').replace(/\/$/, '');
      Promise.all([
        loadLeaflet(mapEl.getAttribute('data-leaflet-js'), mapEl.getAttribute('data-leaflet-css')),
        fetchJson(api + '/hfd/points'),
        fetchJson(api + '/hfd/cities').catch(function () { return { cities: [] }; })
      ]).then(function (res) {
        L = res[0];
        points = (res[1].points || []).filter(function (p) {
          return typeof p.lat === 'number' && typeof p.lng === 'number';
        });
        cities = res[2].cities || [];
        cities.forEach(function (c) { cityByHe[c.he] = c; });
        if (!cities.length) {
          var counts = {};
          points.forEach(function (p) { counts[p.city] = (counts[p.city] || 0) + 1; });
          cities = Object.keys(counts).map(function (he) { return { he: he, count: counts[he] }; });
          cities.forEach(function (c) { cityByHe[c.he] = c; });
        }

        var updated = res[1].updated ? new Date(res[1].updated) : null;
        if (updated && !isNaN(updated)) {
          var text = fill(L10N.updated, { date: updated.toLocaleDateString(locale === 'he' ? 'he-IL' : locale === 'ru' ? 'ru-RU' : 'en-GB') });
          if (res[1].stale) text += ' · ' + L10N.stale;
          ui.updated.textContent = text;
        }

        var fromUrl = '';
        try { fromUrl = new URL(window.location.href).searchParams.get('city') || ''; } catch (e) { /* noop */ }
        state.city = (fromUrl && cityByHe[fromUrl]) ? fromUrl
          : (cityByHe[config.defaultCity] ? config.defaultCity : (cities[0] ? cities[0].he : ''));
        ui.searchInput.value = cityName(state.city);
        ui.searchClear.hidden = !ui.searchInput.value;

        map = L.map(mapEl, { scrollWheelZoom: false, worldCopyJump: false });
        renderer = L.canvas({ padding: 0.5 });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
          maxZoom: 18
        }).addTo(map);
        map.on('click', function () { showPlaceholder(); });
        render();
      }).catch(fail);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          start();
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(mapEl);
    } else {
      start();
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hfd-points]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
